import { fetchExperiences } from "@/services/supabaseService";
import { useQuery } from "@tanstack/react-query";
import ExperienceCard from "./ExperienceCard";
import { ArrowRight } from "lucide-react";
import { useNavigate } from "react-router-dom";
import { Button } from "./ui/button";

const ProfessionalExperience = () => {
  const navigate = useNavigate();
  const navigateToPage = (path: string) => {
    navigate(path);
  };
  const { data: experiences = [] } = useQuery({
    queryKey: ["experiences"],
    queryFn: fetchExperiences,
  });
  return (
    <div id="experience" className="container max-w-6xl mx-auto py-20 px-6">
      <div className="animate-slide-down mb-12">
        <div className="uppercase text-sm tracking-wider text-gray-400 mb-2">
          Experience
        </div>
        <h2 className="text-4xl font-bold mb-2 text-teal">
          PROFESSIONAL EXPERIENCE
        </h2>
      </div>

      <div className="relative mb-8">
        {/* Timeline line */}
        <div className="absolute left-0 top-0 bottom-0 w-px bg-gray-700"></div>

        {experiences.map((job, index) => (
          <ExperienceCard
            key={job.id}
            experience={job}
            index={index}
            showResponsibilities={2}
          />
        ))}
      </div>

      <div className="flex justify-center mt-12">
        <Button
          onClick={() => navigateToPage("/experience")}
          className="bg-teal hover:bg-teal-dark text-navy-dark flex items-center gap-2"
        >
          View More
          <ArrowRight className="h-4 w-4" />
        </Button>
      </div>
    </div>
  );
};

export default ProfessionalExperience;
